// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
import type { DropResult } from 'react-beautiful-dnd';
import type { Issue } from '../../../../services/board-store/types';

// returns dropParams that we send to all participants via telepointer event
// dropParams are used to locate a card that needs to be animated
export const getDropParams = ({
	issueId,
	issues,
	dragStop,
}: {
	issueId: number;
	dragStop: DropResult;
	issues: Issue[];
}) => {
	const sourceIssue = issues.find((issue) => issue.id === issueId);

	const destinationIssueIndex = dragStop.destination?.index;
	const destinationStatusId = Number(
		(dragStop.destination?.droppableId || '').split('COLUMN::')[1] || '',
	);
	const destinationColumnIssues = issues.filter((i) => i.statusId === destinationStatusId);
	const destinationIssue =
		typeof destinationIssueIndex === 'number'
			? destinationColumnIssues[destinationIssueIndex]
			: undefined;
	const destinationRelativeIssue =
		!destinationIssue && typeof destinationIssueIndex === 'number' && destinationIssueIndex > 0
			? destinationColumnIssues[destinationIssueIndex - 1]
			: undefined;

	// issues hasn't been moved anywhere - just a lift and drop on the same place
	if (
		sourceIssue?.statusId === destinationStatusId &&
		(issueId === destinationIssue?.id || issueId === destinationRelativeIssue?.id)
	) {
		return undefined;
	}

	return {
		// source issue - dropped card
		sourceNodeId: issueId,
		// that's a card that gets pushed by the dropped card.
		// It is used in calculations of destination coordinates for animation
		destinationNodeId: destinationIssue?.id,
		// relative destination card in case there's no destinationNodeId
		// e.g. when dropped in the end of a column, relative issue would be the last card in that column
		destinationRelativeNodeId: destinationRelativeIssue?.id,
		// column
		destinationColumnId: destinationStatusId,
	};
};
